import { Flex, Text, Box, Menu, MenuButton, Button } from "@chakra-ui/react";
import { IconContainer } from "./styles";
import { MdOutlineSync } from "react-icons/md";
import { FaPlus } from "react-icons/fa";
import { green700 } from "core/resources/theme/colors";
import useModal from "../hooks/useModal";
import { useValidatePermission } from "core/features/auth/hooks/useValidatePermission";

function HeaderGestaoJobs() {
  const { setIsOpen, setIsEditing } = useModal();
  const { hasPermission } = useValidatePermission();

  const canCreateJob = hasPermission(["RecurringJobGroup.Cadastrar"]);

  const handleOpenCreateModal = () => {
    setIsOpen(true);
    setIsEditing(false);
  };

  return (
    <Flex
      as="header"
      w="100%"
      justifyContent="space-between"
      h="24"
      px="12"
      borderColor="gray.500"
      boxShadow="0px 1px 4px #0000007D"
    >
      <Flex flexDir="row" alignItems="center">
        <IconContainer>
          <MdOutlineSync size={32} color="#fff" />
        </IconContainer>
        <Text
          fontSize="26px"
          fontWeight="medium"
          letterSpacing="tight"
          justifyContent="center"
          color="#676C77"
          ml="2"
        >
          Execução de Jobs
        </Text>
      </Flex>
      {canCreateJob && (
        <Box mt="7">
          <Menu>
            <MenuButton
              as={Button}
              leftIcon={<FaPlus fontSize={12} />}
              fontSize={16}
              fontWeight="medium"
              _hover={{ opacity: 0.73 }}
              px={"8px"}
              bg={green700}
              rounded={20}
              color={"white"}
              _expanded={{ bg: green700 }}
              onClick={handleOpenCreateModal}
            >
              Novo Job
            </MenuButton>
          </Menu>
        </Box>
      )}
    </Flex>
  );
}

export default HeaderGestaoJobs;
